import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=b44a15aa&scoped=true"
import script from "./QuestionPreview.vue?vue&type=script&lang=js"
export * from "./QuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&id=b44a15aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a15aa",
  null
  
)

export default component.exports